/*-- import aliases -----------
'!/...' -> project root
'~/...' -> js folder root
-----------------------------*/
import { setup } from '~/core';
setup();

import '~/global/_body';
import '~/global/_alert';
import '~/global/_header';
import '~/global/_footer';
import '~/global/_preferredLocation';
import '~/global/_dialogModal';

import '~/global/_siteModals';

import '~/components/_accordion';
import "~/components/_alternativeParts";
import '~/components/_featureBlock';
import '~/components/_featureBlockHoverable';
import '~/components/_productInfoBox';
import '~/components/_table';
import '~/components/_featureList';
import '~/components/_tabs';
import '~/components/_forms';
import '~/components/_orderSummary';
import "~/components/_checkout";
import '~/components/_partDetail';